import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CloseIcon from "@mui/icons-material/Close";

const defaultLicenseCount = 12;

export default function LicensesTab() {
  const [open, setOpen] = useState(false);
  const [currentLicenses, setCurrentLicenses] = useState(defaultLicenseCount);
  const [requestedLicenses, setRequestedLicenses] = useState(defaultLicenseCount);

  useEffect(() => {
    if (!open) return;
    setCurrentLicenses(defaultLicenseCount);
    setRequestedLicenses(defaultLicenseCount);
  }, [open]);

  const decrement = () => {
    setRequestedLicenses((prev) => Math.max(1, prev - 1));
  };

  const increment = () => {
    setRequestedLicenses((prev) => prev + 1);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
        Licenses
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.8, mb: 2 }}>
        Review your paid licenses and request additional seats when ready.
      </Typography>

      <Card elevation={3} sx={{ maxWidth: 420 }}>
        <CardContent sx={{ display: "grid", gap: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Current Licenses
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            {currentLicenses}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            Coming soon: billing for additional licenses will be available here.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button variant="contained" onClick={() => setOpen(true)}>
              Manage Licenses
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6">Licenses</Typography>
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "grid", gap: 2 }}>
            <Box>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                Current paid licenses
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                {currentLicenses}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" sx={{ opacity: 0.7, mb: 1 }}>
                Requested licenses
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <IconButton onClick={decrement} size="large">
                  <RemoveCircleOutlineIcon />
                </IconButton>
                <Typography variant="h4" sx={{ minWidth: 48, textAlign: "center" }}>
                  {requestedLicenses}
                </Typography>
                <IconButton onClick={increment} size="large">
                  <AddCircleOutlineIcon />
                </IconButton>
              </Box>
            </Box>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              License changes will be available soon for administrator accounts.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" disabled={requestedLicenses === currentLicenses}>
            Agree &amp; Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
